import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#838A98"
        d="M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0Zm0 9.6a.6.6 0 1 1 0-1.2.6.6 0 0 1 0 1.2Zm.6-1.8H5.4V2.4h1.2v5.4Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
